import Iconify from "@/components/ui/Iconify";
import PostAvatar from "@/components/ui/PostAvatar";
import Image from "next/image";

const PDW_PlaceTabTidingsSection = ({ isCssForDialog }) => {
  return (
    <div className="w-full min-h-[70vh] flex flex-col divide-y divide-black/[0.08] dark:divide-white/[0.14] gap-2">
      {new Array(4).fill(0).map((_, index) => (
        <div key={index} className="w-full flex flex-col gap-2 px-2 py-4">
          <div className="w-full flex items-center gap-3">
            <PostAvatar className={"!h-9 !min-w-9"} />
            <span className="font-semibold">아스카라면</span>
          </div>
          <div
            className={`w-full max-w-full overflow-x-auto rounded-xl overflow-hidden flex gap-0.5 ${
              isCssForDialog ? "h-[150px]" : "h-[250px]"
            }`}
          >
            {new Array(5).fill(0).map((_, index) => (
              <div key={index} className="relative aspect-square">
                <Image
                  src={"/person.png"}
                  alt="food"
                  fill
                  sizes="(max-width: 768px) 100vw,(max-width: 1200px) 50vw,33vw"
                  className={`object-cover ${index === 0 && "rounded-l-xl"} ${
                    index + 1 === 5 && "rounded-r-xl"
                  }`}
                />
              </div>
            ))}
          </div>
          <p className="w-full">
            <span className="font-semibold">발표</span> Lorem ipsum dolor sit
            amet consectetur.
          </p>
          <p className="w-full text-black/70 dark:text-white/70">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Sed
            recusandae suscipit a doloremque totam incidunt! Obcaecati molestias
            culpa libero laborum dolor inventore, sed optio voluptatum,
            praesentium illo ipsum provident suscipit.
          </p>
          <span className="text-black/40 dark:text-white/40">2024.03.24</span>
          <div className="w-full flex items-center gap-1">
            <Iconify icon={"mdi-light:heart"} className={"!text-pink-600"} />
            <span>
              좋다 <b>4</b>
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PDW_PlaceTabTidingsSection;
